import type { CSSProperties } from 'react';
import type { ToastOptions } from 'react-toastify';
import { toast } from 'react-toastify';

import { hubToastTransition } from './HubToastContainer';
import type { ToastType } from './toast-type';
import { ToastCloseButton } from './ToastCloseButton';
import type { ToastContentProps } from './ToastContent';
import { ToastContent } from './ToastContent';

const defaultOptions: ToastOptions = {
	hideProgressBar: true,
	position: 'top-center',
	autoClose: 3000,
	transition: hubToastTransition,
};

const defaultToastStyle: CSSProperties = {
	minWidth: 450,
	padding: '1.25rem',
};

/**
 * Wrapper around react-toastify's `toast` function with hub styling.
 * @param TitleComponent ReactNode for toast title
 * @param message ReactNode for toast message
 * @param options Options to pass to react-toastify's `toast`
 */
export function createToast(
	TitleComponent: ToastContentProps['TitleComponent'],
	message: ToastContentProps['message'],
	type: ToastType,
	options?: ToastOptions
) {
	return toast(
		<ToastContent
			TitleComponent={TitleComponent}
			message={message}
			type={type}
		/>,
		{
			...defaultOptions,
			...options,
			autoClose: options?.autoClose ?? defaultOptions.autoClose,
			style: {
				...defaultToastStyle,
				...options?.style,
			},
			bodyStyle: {
				padding: '0',
			},
			closeButton: (props) => <ToastCloseButton {...props} />,
		}
	);
}
